import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
var Icon = function(prop) {
    return /*#__PURE__*/ _jsx("img", _object_spread_props(_object_spread({}, prop), {
        style: {
            marginRight: "8px"
        },
        width: 20,
        height: 20,
        alt: "Savvycoin logo",
        src: "https://dex.savvycom.ai/images/tokens/SVC.png"
    }));
};
export default Icon;
